/**
 * Copia texto al portapapeles.
 *
 * `navigator.clipboard` solo existe en contextos seguros (https o localhost),
 * así que en entornos servidos por http se cae al `execCommand('copy')`
 * clásico sobre un textarea fuera de pantalla.
 *
 * @param {string} text Texto a copiar
 * @returns {Promise<boolean>} true si se copió
 */
export async function copyToClipboard(text) {
  const value = String(text ?? '');

  if (!value) return false;

  if (navigator?.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (error) {
      // Permiso denegado o contexto inseguro: seguimos con el fallback.
    }
  }

  try {
    const textarea = document.createElement('textarea');

    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.select();

    const copied = document.execCommand('copy');

    document.body.removeChild(textarea);

    return copied;
  } catch (error) {
    return false;
  }
}

export default copyToClipboard;
